import {BootstrapIcon} from "src/app/services/header.service";
import {Userrole} from "src/app/shared/interfaces/user";

export interface NavItem {
  title: string;
  icon: BootstrapIcon | string;
  link: string;
  activePath: string[];
  activeColor?: string;
  visibleToRoles: Userrole[];
}

const userrole = Userrole;

// TODO: bind active path to active component from route property
export const navItems: NavItem[] = [
  {
    title: "Dashboard",
    icon: BootstrapIcon.dashboard,
    link: "/dashboard",
    activePath: ["/dashboard"],
    visibleToRoles: [
      Userrole.Mitarbeiter,
      Userrole.Produktionsleiter,
      Userrole.Schichtleiter,
      Userrole.Teamleiter,
      Userrole.Techniker,
    ],
  },
  {
    title: "Wissensdatenbank",
    icon: BootstrapIcon.knowledgebase,
    link: "/kd",
    activePath: ["kd"],
    visibleToRoles: [
      Userrole.Mitarbeiter,
      Userrole.Produktionsleiter,
      Userrole.Schichtleiter,
      Userrole.Teamleiter,
      Userrole.Techniker,
    ],
  },
  {
    title: "Stillstandsmeldung",
    icon: BootstrapIcon.standstill,
    link: "/er",
    activePath: ["er"],
    activeColor: '#ff0000',
    visibleToRoles: [
      Userrole.Mitarbeiter,
      Userrole.Produktionsleiter,
      Userrole.Schichtleiter,
      Userrole.Teamleiter,
      Userrole.Techniker,
    ],
  },
  {
    title: "Eskalationen",
    icon: BootstrapIcon.escalation,
    link: "/escalations",
    activePath: ["escalations", "=escalation"],
    activeColor: 'hsla(29, 90%, 54%, 1)',
    visibleToRoles: [
      Userrole.Produktionsleiter,
      Userrole.Schichtleiter,
      Userrole.Teamleiter,
      Userrole.Techniker,
    ],
  },
  {
    title: "Stillstandsübersicht",
    icon: BootstrapIcon.workplaces,
    link: "/workplaces",
    activePath: ["workplaces", "=report"],
    visibleToRoles: [
      Userrole.Mitarbeiter,
      Userrole.Produktionsleiter,
      Userrole.Schichtleiter,
      Userrole.Teamleiter,
      Userrole.Techniker,
    ],
  },
  {
    title: "Admin Dashboard",
    icon: BootstrapIcon.dashboard,
    link: "/admin/dashboard",
    activePath: ["admin/dashboard"],
    visibleToRoles: [Userrole.Admin],
  },
  {
    title: "Benutzerverwaltung",
    icon: BootstrapIcon.users,
    link: "/admin/users",
    activePath: ["users"],
    visibleToRoles: [Userrole.Admin],
  },
  {
    title: "Arbeitsplatzverwaltung",
    icon: BootstrapIcon.workstations,
    link: "/admin/workstations",
    activePath: ["admin/workstation"],
    visibleToRoles: [Userrole.Admin],
  },
  {
    title: "Produktionslinienverwaltung",
    icon: BootstrapIcon.productionLines,
    link: "/admin/productionLines",
    activePath: ["admin/productionLines"],
    visibleToRoles: [Userrole.Admin],
  },
  {
    title: "KI-Verwaltung",
    icon: BootstrapIcon.ai,
    link: "admin/ai-configuration",
    activePath: ["admin/ai-configuration"],
    visibleToRoles: [Userrole.Admin],
  },
  {
    title: "24h-Dashboard",
    icon: BootstrapIcon.dailyDashboard,
    link: "/report-dashboards/daily",
    activePath: ["report-dashboards/daily"],
    visibleToRoles: [Userrole.Teamleiter],
  }, {
    title: "7-Tage-Dashboard",
    icon: BootstrapIcon.weeklyDashboard,
    link: "/report-dashboards/weekly",
    activePath: ["report-dashboards/weekly"],
    visibleToRoles: [Userrole.Teamleiter],
  },
];
